var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-label": "Flask",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 6h14M27 6v17L11 51a5 5 0 0 0 4.4 7.5h33.2A5 5 0 0 0 53 51L37 23V6",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 40h27l6.4 11.4a2.8 2.8 0 0 1-2.5 4.1H14.6a2.8 2.8 0 0 1-2.5-4.1z",
    fill: "#3aa7b5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 48,
    r: 2.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 44,
    r: 1.8,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.75f64f97c5e0716745d5c899bc6832b6.svg";
export { ForwardRef as ReactComponent };